import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDownloads(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/ExpedientesDigitales/Descargas', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
